import React from 'react'
import { factoryFullBleeds } from 'src/editor/EditorCard'
import { DesignColors } from 'src/editor/api'
import { CardFragment } from 'src/graphql/generated/graphql'
import { selectedVariationId } from 'src/redux/selectors/editor'
import { EditorBackgroundColor } from './EditorBackgroundColor'
import { useDesignColorsBySendableCardId } from 'src/react_query'

type EditorCardColorBackgroundProps = {
  card?: CardFragment
}

const EditorCardColorBackground: React.FC<
  EditorCardColorBackgroundProps
> = props => {
  const { card } = props

  const fullBleeds = card ? factoryFullBleeds(card) : []

  const sendableCardId = card
    ? (selectedVariationId(card, fullBleeds) ?? card.detailedSendableCard?.id)
    : undefined

  const designColorsQuery = useDesignColorsBySendableCardId({
    id: sendableCardId,
    quantity: 1,
  })

  const designColors: DesignColors = {
    palette: designColorsQuery.data,
    isLoading: designColorsQuery.isLoading,
  }

  const cardColor = designColors?.palette?.[0] ?? undefined

  return (
    <EditorBackgroundColor
      startColor="#F1E9F9"
      endColor={
        cardColor &&
        `rgb(${cardColor.red}, ${cardColor.green}, ${cardColor.blue})`
      }
    />
  )
}

export default EditorCardColorBackground
